<template>
    <div>
        <primer-payment-method-form v-if="!isUSA" :submitButtonText="$t('PAYMENT_CONFIRM')" :orderValue="orderValue" hideCard="true"/>
        <card-details-form
            v-if="stripeMounted"
            class="max-w-sm mx-auto"
            @registered="handleSuccessfulRegistration"
            :show-order-summary="true"
            :allow-skip-card="allowNoCard"
            :enable-coupon-field="false"/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SECTION_DELIVERY } from '@/constants/Registration';
import CardDetailsForm from '@/components/forms/register/CardDetailsForm';
import PrimerPaymentMethodForm from '@/components/forms/cardDetails/PrimerPaymentMethodForm';

export default {
    name: 'CardDetails',
    components: {
        CardDetailsForm,
        PrimerPaymentMethodForm,
    },
    data() {
        return {
            submitted: false,
        };
    },
    mounted() {
        if (!this.$store.getters['register/getSectionCompleted'](SECTION_DELIVERY)) {
            this.$router.push({ name: 'register.delivery' });
        }

        this.$scrollTo('#app');

        this.$root.$on('close-card-form', (payload) => {
            if (!this.submitted) {
                this.completeRegistration(payload);
            }
        });
    },
    methods: {
        ...mapActions({
            registerCanvassedCustomer: 'register/registerCanvassedCustomer',
        }),
        completeRegistration(payload) {
            this.submitted = true;

            this.registerCanvassedCustomer({ payment_token: payload.token, payment_method: payload.payment_method, gateway: 'Primer' })
                .then(() => {
                    this.handleSuccessfulRegistration();
                }).catch((error) => {
                    this.errorHandler.setResponse(error.response && error.response.data);
                    this.submitted = false;
                    this.$root.$emit('payment-error', error);
                });
        },

        handleSuccessfulRegistration() {
            this.$store.commit('register/resetState');
            this.$store.commit('account/setSetupIntent', null);
            this.$router.push({ name: 'canvasser-register.confirmation' });
        },
    },
    computed: {
        ...mapGetters({
            stripeMounted: 'cookies/isStripeMounted',
            source: 'canvasser/getSource',
            isUSA: 'localisation/isUSA',
        }),
        allowNoCard() {
            return !this.source?.card_required;
        },
        orderValue() {
            return process.env.VUE_APP_BOX_PRICE * 100;
        },
    },
};
</script>
